import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import { Timeline as AntTimeline } from 'antd';
import styled from 'styled-components';
import { getLuminance } from 'polished';

function generateTextColor(colorPalletes) {
  var colorScheme = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'primary';
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'default';
  var colorSchemeIsBright = getLuminance(colorPalletes[colorScheme]) > 0.5;

  if (type === 'primary') {
    return colorSchemeIsBright ? colorPalletes.dark : colorPalletes.light;
  }

  return colorPalletes[colorScheme];
}

var TimelineItem = styled(AntTimeline.Item)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .ant-timeline-item-head{\n    background-color: ", ";\n    border-color: ", ";\n  }\n  .ant-timeline-item-tail {\n    display: block;\n  }\n  .ant-timeline-item-tail {\n    position: absolute;\n    top: 15px;\n    left: 4px;\n    height: calc(100% - 18px);\n    border-left: 2px solid ", ";\n  }\n  .ant-timeline-item-tail {\n      display: block;\n  }\n"])), function (props) {
  return props.headColor ? props.theme.colors[props.headColor] : 'transparent';
}, function (props) {
  return props.theme.colors[props.headColor || 'primary'];
}, function (props) {
  return generateTextColor(props.theme.colors, props.tailcolor, props.type);
});
AntTimeline.Item = TimelineItem;
var CustomTimeline = AntTimeline;
export default CustomTimeline;